import { Box, Divider } from '@mui/material';

import { AddRequirements } from './AddRequirements';
import { GetMemberHlrDetailsQuery } from 'src/graphql/generated';

type AddRequirementsProps = {
  cycleDate: Date;
  hlrDetailsData?: GetMemberHlrDetailsQuery;
};

const HighLevelRequirements = ({ cycleDate, hlrDetailsData }: AddRequirementsProps) => {
  return (
    <Box sx={{ mt: 3, width: '100%' }}>
      <Divider sx={{ mb: 3 }} />
      <AddRequirements cycleDate={cycleDate} hlrDetailsData={hlrDetailsData} />
    </Box>
  );
};
export { HighLevelRequirements };
